exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bc-button {\n  height: 42px !important;\n  width: 140px !Important;\n  font-size: 15px !important;\n}\n.bc-button-primary {\n  color: #fff !important;\n}\n.bc-button-large {\n  font-size: 16.5px !important;\n  height: 50px !important;\n  width: 160px !important;\n}\n.bc-button-round {\n  border-radius: 500px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/Button/Button.less
// module id = 852
// module chunks = 0